<template>
  <div id="my-support">
    <div class="row reverse-mobile" id="my-contracts">
      <div class="col-12 col-md-3">
        <UserMenu></UserMenu>
      </div>
      <div class="col-12 col-md-9">
        <div class="row mb-4">
          <div class="d-flex flex-row align-items-center">
            <i class="material-icons material-icons-title mr-2">contact_support</i>
            <h2 class="mt-2">Support information</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
export default {
  name: "MySupport",
  components: {
    UserMenu
  }
};
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}
.card:first-child {
  margin-right: 1rem;
}
.contact-row {
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 0 1rem;
}
.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}
</style>
